<template>
  <f-dashboard-layout>
    <template #layout-dashboard-header>
      <f-dashboard-header 
        :logo="logoUrl"
        :links="links"
      ></f-dashboard-header>
    </template>
  </f-dashboard-layout>
</template>

<script>
  import { ref, reactive, watch, computed, nextTick } from 'vue'
  import { useStore } from '@freebe/sdk/store'
  import useRoles from '@composables/use-roles'
  import router from '@core/router'
  import logoUrl from '@assets/images/logo.png'

  export default {
    async setup () {
      const { me: user } = useStore('@admin/users')
      const { checkAuthentication } =  useStore('@admin/auth')
      const { hasRole, checkPermissions } = useRoles()

      function verifyAuth (newValue) {
        return checkAuthentication().catch(error => {
          console.error(error.message)

          router.push({ 
            name: 'login',
            query: {
              redirect_uri: newValue?.fullPath || '/'
            }
          })
        })
      }

      function hasPermissions (permissions = []) {
        for (let i = 0; i < permissions.length; i++) {
          if (!checkPermissions(permissions[i])) {
            return false
          }
        }

        return true
      }

      watch(() => router, verifyAuth, { deep: true, immediate: true })

      const links = computed(() => {
        return [{
          name: 'Dashboard',
          icon: 'home',
          to: user.value.partner_ids?.length && !hasRole(['admin', 'superadmin']) 
              ? { name: 'growth-cashback', params: { partner_id: user.value.partner_ids[0] }}
              : { name: 'home' },
          exact: true,
        }, {
          name: 'Admins',
          icon: 'user',
          to: { path: '/admins' },
          permissions: ['users:find', 'roles:find'],
        }, {
          name: 'Partenaires',
          icon: 'user',
          to: { path: '/partners' },
          permissions: ['partners:find'],
          roles: ['admin', 'superadmin'],
        }, {
          name: 'Pricing',
          icon: 'euro',
          to: { path: '/pricing' },
          permissions: ['freebe/pricing/codes:find'],
        }, {
          name: 'Freebe',
          icon: 'user',
          to: { path: '/freebe' },
          permissions: ['freebe/users:find'],
        }].filter(route => 
          (!route.permissions?.length || hasPermissions(route.permissions))
          && (!route.roles?.length || hasRole(route.roles))
        )
      })

      await verifyAuth()

      return {
        links,
        logoUrl,
      }
    },
  }
</script>

<style lang="scss">
  .layout-dashboard {
    position: relative;
    max-height: 100vh;
    overflow: hidden;

    .dashboard-content {
      position: relative;
      height: max-content;
      width: 100vw;
      max-height: 100vh;
      max-width: 1200px;
      // overflow: hidden;
      margin: 0 auto;
    }
  }
</style>